export const SOLUTIONS = [
  {
    id: "photovoltaique",
    slug: "photovoltaique",
    n: "01",
    title: "Photovoltaïque",
    subtitle: "Installation sur-mesure",
    lead: "Toitures, hangars, ombrières et pose au sol — dimensionnement précis, matériel Tier 1 et suivi de production.",
    bullets: [
      "Autoconsommation & revente totale",
      "Matériel Tier 1 · Garantie 10 ans",
      "Dimensionnement & 3D",
    ],
    image: "https://cdn.pixabay.com/photo/2015/07/27/14/11/solar-power-862602_1280.jpg",
    accent: "emerald",
  },
  {
    id: "controle",
    slug: "controle",
    n: "02",
    title: "Contrôle Indépendant",
    subtitle: "Fin de chantier PV",
    lead: "Un audit électrique, mécanique et de conformité par un tiers indépendant — sécurisez votre investissement.",
    bullets: [
      "Conformité normative",
      "Rapport détaillé & photos IR",
      "Levée de réserves",
    ],
    image: "https://plus.unsplash.com/premium_photo-1682148026899-d21f17c04e80?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    accent: "solar",
  },
  {
    id: "maintenance",
    slug: "maintenance",
    n: "03",
    title: "Maintenance & Nettoyage",
    subtitle: "Rendement préservé",
    lead: "Contrats de maintenance préventive, nettoyage saisonnier et intervention rapide pour maintenir votre rendement.",
    bullets: [
      "Monitoring & alertes",
      "Nettoyage écologique",
      "Contrats annuels",
    ],
    image: "https://plus.unsplash.com/premium_photo-1682145354957-713207b0387c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    accent: "emerald",
  },
  {
    id: "irve",
    slug: "irve",
    n: "04",
    title: "Bornes IRVE",
    subtitle: "Mobilité électrique",
    lead: "Installation, maintenance et supervision de bornes de recharge, du particulier pro aux flottes de collectivité.",
    bullets: [
      "IRVE 1 · 2 · 3 habilités",
      "Aides ADVENIR",
      "Supervision cloud",
    ],
    image: "https://images.pexels.com/photos/33661086/pexels-photo-33661086.jpeg?_gl=1*16u8ltr*_ga*MzI0MDc1ODEyLjE3ODY4ODM2ODY.*_ga_8JE65Q40S6*czE3ODY4ODM2ODUkbzEkZzEkdDE3ODY4ODU3NTUkajI5JGwwJGgw",
    accent: "solar",
  },
  {
    id: "securite",
    slug: "securite",
    n: "05",
    title: "Sécurité Chantier",
    subtitle: "Filets & sécurisation",
    lead: "Pose de filets périphériques et sous-face par des équipes formées, pour des chantiers en hauteur sans compromis.",
    bullets: [
      "Filets périphériques & sous-face",
      "Conformité travail en hauteur",
      "Interventions rapides",
    ],
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1600&q=80",
    accent: "emerald",
  },
  {
    id: "bardage",
    slug: "bardage",
    n: "06",
    title: "Bardage",
    subtitle: "Isolation & finition façade",
    lead: "Pose de bardage métallique et isolé pour bâtiments agricoles, industriels et tertiaires — étanchéité, esthétique et performance thermique.",
    bullets: [
      "Bardage simple peau & double peau isolé",
      "Étanchéité & isolation thermique",
      "Finitions sur-mesure",
    ],
    image: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?auto=format&fit=crop&w=1600&q=80",
    accent: "solar",
  },
  {
    id: "construction-metallique",
    slug: "construction-metallique",
    n: "07",
    title: "Construction Métallique",
    subtitle: "Charpente & structure",
    lead: "Conception, fabrication et montage de charpentes et structures métalliques pour hangars, entrepôts et bâtiments agricoles ou industriels.",
    bullets: [
      "Charpente & ossature métallique",
      "Hangars, entrepôts, bâtiments agricoles",
      "Études & plans sur-mesure",
    ],
    image: "https://images.unsplash.com/photo-1649587345666-0f4ad68aa723?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    accent: "emerald",
  },
];

export const MARKETS = [
  {
    id: "agricole",
    title: "Agricole",
    kicker: "/A",
    lead: "Rentabilisez toitures et hangars. Autoconsommation ou revente, ombrières agrivoltaïques.",
    image: "https://cdn.pixabay.com/photo/2017/08/21/20/29/solar-2666770_1280.jpg",
  },
  {
    id: "industriel",
    title: "Industriel & Tertiaire",
    kicker: "/B",
    lead: "Décarbonez votre site, sécurisez votre facture énergétique, électrifiez vos flottes.",
    image: "https://cdn.pixabay.com/photo/2026/06/23/06/18/06-18-49-31_1280.jpg",
  },
  {
    id: "collectivite",
    title: "Collectivités & Public",
    kicker: "/C",
    lead: "Marchés publics, ombrières, bornes IRVE et bâtiments communaux — un partenaire unique.",
    image: "https://cdn.pixabay.com/photo/2020/02/06/15/11/solar-4824604_1280.jpg",
  },
];

export const PROCESS = [
  { n: "01", title: "Étude", text: "Diagnostic gisement solaire, cadastre, faisabilité technique et administrative." },
  { n: "02", title: "Dimensionnement", text: "Calepinage, câblage, choix onduleurs, simulation de production." },
  { n: "03", title: "Installation", text: "Pose par équipes certifiées, sécurisation du chantier, mise en service." },
  { n: "04", title: "Suivi", text: "Monitoring, maintenance préventive, garantie 10 ans, service client dédié." },
];

export const KPIS = [
  { value: "10", suffix: "ans", label: "Garantie décennale" },
  { value: "500", suffix: "HTF", label: "QualiPV certifié" },
  { value: "24", suffix: "h", label: "Délai de réponse" },
  { value: "100", suffix: "%", label: "Chantiers assurés" },
];
